<template>
  <div class="app">

  </div>
</template>

<script>
export default {
  created () {
    this.$store.dispatch('logOut').then(() => {
      localStorage.clear()

      this.$router.push({
        name: 'Login'
      })
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Logout.vue?26ab7ace